function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.625 0.75H1.375C1.11979 0.75 0.910156 0.841146 0.746094 1.02344C0.582031 1.1875 0.5 1.38802 0.5 1.625C0.5 1.86198 0.582031 2.07161 0.746094 2.25391L5.75 7.23047V12.3438C5.75 12.6172 5.85026 12.8359 6.05078 13L7.80078 14.5312C7.98307 14.6953 8.18359 14.7682 8.40234 14.75C8.63932 14.7318 8.83984 14.6406 9.00391 14.4766C9.16797 14.3125 9.25 14.112 9.25 13.875V7.23047L14.2539 2.25391C14.418 2.07161 14.5 1.86198 14.5 1.625C14.5 1.38802 14.418 1.1875 14.2539 1.02344C14.0898 0.841146 13.8802 0.75 13.625 0.75ZM8.375 6.875V13.875L6.625 12.3438V6.875L1.375 1.625H13.625L8.375 6.875Z",
  fill: "currentColor"
});

var SvgFilter = function SvgFilter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFilter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/filter.ab1c7f07.svg";
export { ForwardRef as ReactComponent };